import * as types from '../constants/ActionTypes';
import { loggedIn } from '../lib/auth';


const INITIAL_STATE = {
    error: null,
    loggedIn: loggedIn(),
    conversationDetails: {},
    limitedLogin: false,
    message: null,
    verifiedDOB: false,
    verifiedName: false,
    time: null,
};

export default function sessionReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case types.VERIFY_NAME_SUCCESS:
            return {
                ...state,
                error: null,
                verifiedName: action.verifiedName,
            };

        // Just need to reset error state.
        case types.FORGOT_PIN:
            return {
                ...state,
                error: null,
            };

        case types.RESET_FORGOTTEN_PIN_SUCCESS:
            return {
                ...state,
                error: null,
                message: action.data.info,
                verifiedName: false,
            };

        case types.LIMITED_LOGIN_SUCCESS:
            return {
                ...state,
                limitedLogin: true,
                loggedIn: false,
                error: null,
                ...action,
            };

        // redux-timer-middleware returns the type we define with "_END" appended.
        case types.LIMITED_LOGIN_SEND_MESSAGE_TIMER_END:
            return {
                ...state,
                time: action,
            };

        case types.LOGIN_SUCCESS:
            return {
                ...state,
                loggedIn: true,
                error: null,
                ...action,
            };

        case types.LOGIN_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        case types.LOGOUT_REQUEST:
            return {
                ...state,
                error: null,
                limitedLogin: false,
                loggedIn: false,
                time: null,
                verifiedName: false,
                verifiedDOB: false,
            };

        case types.GET_CONVERSATION_DETAILS_SUCCESS:
            return {
                ...state,
                conversationDetails: action,
                error: null,
            };

        case types.GET_CONVERSATION_DETAILS_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        case types.VERIFY_DOB_SUCCESS:
            return {
                ...state,
                error: null,
                verifiedDOB: action,
            };

        case types.SAVE_PIN_SUCCESS:
            return {
                ...state,
                error: null,
                message: action.data.info,
            };

        case types.SESSION_TIME_SUCCESS:
            const { sessionTimeRemaining } = action.response.data;

            return {
                ...state,
                error: null,
                time: sessionTimeRemaining,
            };

        default:
            return state;

    }
}
